module.exports = __webpack_public_path__ + "img/beachvolley.3dcd4625.svg";